import script from "./EOldObservationHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./EOldObservationHistory.vue?vue&type=script&setup=true&lang=ts"

import "./EOldObservationHistory.vue?vue&type=style&index=0&id=479c9563&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479c9563"]])

export default __exports__